module.exports = __webpack_public_path__ + "assets/img/dgoods-step3-active-green.fb559d03.svg";